import React from 'react';
import remoteFiles from '../../../../../common/remote_files';
import { packageNumbers } from '../../express_numbers';

const ReadMorePackage = ({ onGetStarted }) => {
  const {
    addPackage, conceptFocus, mode, preference, shelfShot
  } = remoteFiles.express.steps.package;
  const {
    step12x, screenerQuestion
  } = remoteFiles.express.steps.base;
  return (
    <>
      <div className="modal_body">
        <div className="express-steps">
          <h3 className="express-steps_title">Packaging</h3>
          <h2 className="express-steps_subtitle">Here’s how it works</h2>
          <div className="express-steps_list">
            <div className="express-steps_item">
              <div className="express-steps_col">
                <div className="express-steps_item-text">
                  <p>Select your audience</p>
                  <p className="-descr">Choose demographics filters.</p>
                </div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ step12x } />
                </div>
              </div>
            </div>
            <div className="express-steps_item">
              <div className="express-steps_col">
                <div className="express-steps_item-text">
                  <p>Create up to 3 screener questions</p>
                  <p className="-descr">Adding screener questions may impact cost and timing.</p>
                </div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ screenerQuestion } />
                </div>
              </div>
            </div>
            <div className="express-steps_item">
              <div className="express-steps_col">
                <div className="express-steps_item-text">
                  <p>Select exercise mode</p>
                  <p className="-descr">Choose from Monadic and Sequential Monadic.</p>
                </div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ mode } />
                </div>
              </div>
            </div>
            <div className="express-steps_item -no-bottom-line">
              <div className="express-steps_col">
                <div className="express-steps_item-text">
                  <p>Add packages</p>
                  <p className="-descr">You can evaluate up to {packageNumbers.itemsMax.express} items.</p>
                </div>
              </div>
              <div className="express-steps_col">
                <div className="express-steps_item-img">
                  <img src={ addPackage } />
                </div>
              </div>
            </div>
            <div className="express-steps_item -no-flex -no-bottom-line">
              <div className="express-steps_header-wrapper">
                <h3 className="express-steps_item-header">buzzback Projectives</h3>
                <div className="express-steps_item-description">
                  For a subset of packages randomly selected, respondents will react to buzzback
                  { ' ' }
                  projective techniques.
                </div>
              </div>
              <div className="express-steps_inner-col">
                <div className="express-steps_col">
                  <div className="express-steps_item-text">
                    <p>Online Shelf</p>
                    <p className="-descr">
                      With Online Shelf, respondents will participate in a "Find Time" exercise and
                      { ' ' }
                      locate the test package on a shelf. Only shown for the first package
                      { ' ' }
                      evaluated.
                    </p>
                  </div>
                </div>
                <div className="express-steps_col">
                  <div className="express-steps_item-img -narrow">
                    <img src={ shelfShot } />
                  </div>
                </div>
              </div>
              <div className="express-steps_inner-col">
                <div className="express-steps_col">
                  <div className="express-steps_item-text">
                    <p>Concept Focus</p>
                    <p className="-descr">
                      With Concept Focus, respondents mark up what they like and dislike and
                      { ' ' }
                      describe why.
                    </p>
                  </div>
                </div>
                <div className="express-steps_col">
                  <div className="express-steps_item-img">
                    <img src={ conceptFocus } />
                  </div>
                </div>
              </div>
            </div>
            <div className="express-steps_item -no-flex">
              <div className="express-steps_header-wrapper">
                <h3 className="express-steps_item-header">Preference</h3>
              </div>
              <div className="express-steps_inner-col">
                <div className="express-steps_col">
                  <div className="express-steps_item-text">
                    <p>Preference question</p>
                    <p className="-descr">
                      Respondents will select their preference. Only available if
                      {' '}
                      {packageNumbers.itemsMin.express}+ packages are
                      { ' ' }
                      included.
                    </p>
                  </div>
                </div>
                <div className="express-steps_col">
                  <div className="express-steps_item-img -narrow">
                    <img src={ preference } />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal_footer -bg-gray -center">
        <div className="modal_footer-button">
          <button className="button modal_button" onClick={ onGetStarted }>
            Get Started
          </button>
        </div>
      </div>
    </>
  );
};

export default ReadMorePackage;
